<template>
  <div v-loading='loadingStatus' style='width: 96%;margin:0 auto;'>
    <!--    <el-link class='title' @click='getInfo'>添加</el-link>-->
    <div class='clipboard-tools'>
      <el-button size='medium' icon='el-icon-document-copy' :disabled='loadingStatus' @click='copyData'>复制数据</el-button>
      <el-button size='medium' icon='el-icon-document-add' :disabled='loadingStatus' @click='pasteData'>粘贴导入</el-button>
    </div>
    <el-form ref='refForm' :model='formData' :rules='rules' :inline='false' label-width='80px'>
      <el-row :gutter='15'>
        <el-col :span='24'>
          <el-form-item label='KOL头像' prop='cover'>
            <ArtistAvatar :img-url='formData.cover_url' @uploaded='getCover'/>
          </el-form-item>
        </el-col>
        <el-col :span='24'>
          <el-form-item label='平台' label-width='100px' prop='code'>
            <el-select v-model="formData.code" placeholder="请选择">
              <el-option
                v-for="item in platforms"
                :key="item.name"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label='红人昵称' label-width='100px' prop="nickname">
            <el-input v-model='formData.nickname' show-word-limit maxlength='100' placeholder="红人在该平台的昵称"/>
          </el-form-item>
          <el-form-item label='平台ID' label-width='100px' prop="account_id">
            <el-input v-model='formData.account_id' show-word-limit maxlength='100' placeholder="比如：抖音号、小红书号"/>
          </el-form-item>
          <el-form-item label='经纪人' label-width='100px' prop="agent_name">
            <el-input v-model='formData.agent_name' show-word-limit maxlength='10'/>
          </el-form-item>
          <el-form-item label='城市' label-width='100px' prop="city">
            <el-input v-model='formData.city' show-word-limit maxlength='10' placeholder="红人IP属地"/>
          </el-form-item>

<!--          <el-form-item label='IP归属' label-width='100px' prop="ip_location">-->
<!--            <el-input v-model='formData.ip_location' show-word-limit maxlength='100'/>-->
<!--          </el-form-item>-->
          <el-form-item label='肤质' label-width='100px' prop="skin_type">
            <el-input v-model='formData.skin_type' show-word-limit maxlength='100'/>
          </el-form-item>
          <el-form-item label='标签' label-width='100px' prop="kol_label">
            <el-input v-model='formData.kol_label' show-word-limit maxlength='100'/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label='直播类型' label-width='100px' prop="live_type">
        <el-radio-group v-model='formData.live_type'>
          <el-radio :label='1'>达播</el-radio>
          <el-radio :label='2'>日播</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label='主页链接' label-width='100px' prop="home_page_link">
        <el-input v-model='formData.home_page_link' maxlength='120' placeholder="红人主页链接，短链接">
          <template slot='append'>
<!--            <el-button icon='el-icon-search' :loading='fetchLoading' title='通过链接抓取数据'-->
<!--                       @click='fetchData'>抓取</el-button>-->
            <el-button icon='el-icon-link' title='点击跳转到主页'
                       @click='openUrl(formData.home_page_link)' ></el-button>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item label='简介' label-width='100px' prop="intro">
        <el-input v-model='formData.intro' type='textarea' :rows='10' placeholder='请输入KOL简介' show-word-limit
                  maxlength='500'/>
      </el-form-item>
      <div class='right-button'>
        <el-button size='medium' type='primary' :disabled='loadingStatus' @click='saveConfirm'>保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import ApeUploader from '@/components/ApeUploader'
import ArtistAvatar from '@/pages/artist/ArtistAvatar'
import { copyTextToClipboard } from '@/utils/sys/copy'

// 支持复制/粘贴导入的字段集合（不含 id、artist_id 等标识字段）
const COPY_FIELDS = ['code', 'account_id', 'home_page_link', 'agent_name', 'city', 'intro', 'cover', 'cover_url', 'nickname', 'ip_location', 'skin_type', 'kol_label', 'live_type']

export default {
  name: 'KolPlatformInfo',
  components: {
    ArtistAvatar,
    ApeUploader
  },
  props: {

    formData: {
      type: Object,
      default() {
        return {
          artist_id: '',
          code: '',
          account_id: '',
          home_page_link: '',
          agent_name: '',
          city: '',
          intro: '',
          cover_url: null,
          nickname: '',
          ip_location: '',
          skin_type: '',
          kol_label: '',
          live_type: 1,
        }
      }
    },
    artistId: {
      type: String

    },
    platforms: {
      type: Array
    }
  },
  // watch: {
  //   platformCode(val) {
  //     this.formData.code = val
  //     this.formData.artist_id = this.artistId
  //     this.getInfo()
  //   }
  // },
  data() {
    return {
      // 已上传图片列表
      uploadFileList: [],
      loadingStatus: false,
      fetchLoading: false,
      allowTypeList: ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/bmp'],
      rules: {
        code: [{ required: true, message: '选择平台', trigger: 'blur' }],
        agent_name: [{ required: true, message: '填写经纪人', trigger: 'blur' }],
        nickname: [{ required: true, message: '红人昵称必填', trigger: 'blur' }],
        account_id: [{ required: true, message: '红人平台ID必填', trigger: 'blur' }],
        home_page_link: [{ required: true, message: '主页链接必填', trigger: 'blur' }],
        city: [{ required: true, message: '填写城市', trigger: 'blur' }],
        intro: [{ required: true, message: '填写简介', trigger: 'blur' }]
      },
      currPlatform: {}
    }
  },
  methods: {
    // 通过主页链接抓取页面数据，仅填充当前未填写的字段
    async fetchData() {
      const url = this.formData.home_page_link
      if (!url) {
        this.$message.warning('请先填写主页链接')
        return
      }
      this.fetchLoading = true
      try {
        const fetched = await this.$api.fetchKolJournal({
          url,
          artist_id: this.formData.artist_id,
          code: this.formData.code
        })
        // 仅对当前为空白的字段，用抓取到的数据填充（可修改后保存）
        const fillFields = ['account_id', 'nickname', 'intro', 'cover_url', 'ip_location', 'skin_type', 'kol_label', 'live_type']
        let filled = 0
        fillFields.forEach((key) => {
          const val = fetched[key]
          const cur = this.formData[key]
          const isEmpty = cur === null || cur === undefined || cur === ''
          if (val !== undefined && val !== null && String(val) !== '' && isEmpty) {
            this.$set(this.formData, key, val)
            filled++
          }
        })
        this.$message.success(filled > 0 ? `抓取成功，已填充 ${filled} 项数据` : '抓取完成，未解析到可填充的新数据')
      } catch (e) {
        // 抓取失败也无所谓，不阻断后续操作
        this.$message.warning('抓取失败或页面无可解析数据')
      } finally {
        this.fetchLoading = false
      }
    },
    // 复制当前表单数据为 JSON 到剪切板（供其他红人/记录粘贴导入）
    copyData() {
      const data = {}
      COPY_FIELDS.forEach((field) => {
        const val = this.formData[field]
        if (val !== null && val !== undefined && val !== '') {
          data[field] = val
        }
      })
      copyTextToClipboard(JSON.stringify(data))
      this.$notify.success('已复制到剪切板')
    },
    // 从剪切板读取 JSON 并填充表单
    async pasteData() {
      let text = ''
      try {
        if (navigator.clipboard && navigator.clipboard.readText) {
          text = await navigator.clipboard.readText()
        }
      } catch (e) {
        text = ''
      }
      if (!text) {
        this.$message.warning('剪切板为空或读取失败，请先复制数据后重试')
        return
      }
      let json = null
      try {
        json = JSON.parse(text)
      } catch (e) {
        this.$message.error('剪切板内容不是有效的 JSON，无法导入')
        return
      }
      this.applyPastedData(json)
    },
    // 将解析后的数据填充到表单，填充后可修改再保存
    applyPastedData(json) {
      if (!json || typeof json !== 'object' || Array.isArray(json)) {
        this.$message.error('导入数据格式不正确')
        return
      }
      COPY_FIELDS.forEach((field) => {
        if (field in json) {
          this.$set(this.formData, field, json[field])
        }
      })
      // 平台不匹配时提示，避免 select 显示为空
      const code = json.code
      if (code && Array.isArray(this.platforms) && !this.platforms.some(p => p.code === code)) {
        this.$message.warning(`平台[${code}]不在当前可选平台中，请重新选择`)
      }
      this.$forceUpdate()
      this.$message.success('粘贴导入成功，可修改后保存')
    },
    show() {
      this.getInfo()

      // this.formData.code = code
      // this.formData.artist_id = this.artistId
      // this.currPlatform = this.platforms.find(value => value.code === code)
    },
    getCover(val) {
      this.formData.cover = val.id || null
      this.formData.cover_url = val.full_path || null
      this.uploadFileList = [{ id: val.id, url: val.full_path }]
      this.$forceUpdate()
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      // console.log('file',file)
      this.formData.cover = file.id
      this.formData.cover_url = file.full_path || null
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.cover = 0
      this.formData.cover_url = null
      this.uploadFileList = fileList
    },
    // 附件上传成功回调
    handleAttachmentUploadSuccess(file, fileList) {
      this.formData.attachment = file.id
      this.attachmentUploadFileList = fileList
    },
    // 附件删除回调
    handleAttachmentUploadRemove(file, fileList) {
      this.formData.attachment = 0
      this.attachmentUploadFileList = fileList
    },
    // 图片上传自定义验证
    apeUploaderVerify(rule, value, callback) {
      if (rule.required && !this.formData.cover) {
        callback(new Error(rule.message))
      }
      callback()
    },
    //保存
    saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs['refForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
      return true
    },
    // 文章相关信息的保存处理
    async formSubmit() {
      const data = await this.$api.saveArtistPlatformInfo(this.formData)
      if (data) {
        this.$notify.success('保存成功！')
      } else {
        this.$notify.success('失败！')
        this.loadingStatus = false
      }
      this.$emit('close')

    },
    async getInfo() {
      this.loadingStatus = true
      // if (this.formData.code) {
      //   let { info } = await this.$api.getArtistPlatformInfo({
      //     code: this.formData.code,
      //     artist_id: this.formData.artist_id
      //   })
      //
      //   this.formData = info
      //   if (info.cover) {
      //     // this.uploadFileList = [{ id: info.cover_info.id, name: info.cover_info.title, url: info.cover_info.full_path }]
      //     this.uploadFileList = [{ id: info.cover, url: info.cover_url }]
      //   } else {
      //     this.uploadFileList = []
      //   }
      //
      //   this.loadingStatus = false
      // }
    },
    openUrl(href) {
      window.open(href, '_blank')
    }
  },
  created() {
    // this.formData.code = this.platformCode;
    // this.formData.artist_id = this.artistId;
    // this.getInfo()
  }
}
</script>

<style lang="scss" scoped>
.clipboard-tools {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 12px;
}

.right-button {
  padding: 12px;
  text-align: center;
}

//
//.title {
//  font-size: 16px;
//  font-weight: 800;
//  margin-bottom: 20px;
//  margin-top: 10px;
//  margin-left: 10px;
//}
//
//.platform_item {
//  padding: 10px 10px;
//}
//
//.item_data {
//  padding: 4px 0
//}

</style>
